/*
 * ts-common is the basic building blocks of our typescript projects
 *
 * Copyright (C) 2020 Adam van der Kruk aka TacB0sS
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** Storage capacity constants in bytes (binary/base-1024 units) */
/** 1 byte */
export const Byte = 1;
/** 1 kilobyte (1024 bytes) */
export const KB = Byte * 1024;
/** 1 megabyte (1024 KB) */
export const MB = KB * 1024;
/** 1 gigabyte (1024 MB) */
export const GB = MB * 1024;
/** 1 terabyte (1024 GB) */
export const TB = GB * 1024;
/** 1 petabyte (1024 TB) */
export const PB = TB * 1024;
//# sourceMappingURL=storage-capacity-tools.js.map